import DesignTokens from '@tableau/design-tokens';
import React from 'react';
import * as TypeStyle from 'typestyle';

import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { textEllipsis } from '~src/style';
import { applyColor }from '~src/style/ColorService';

const HeaderMenuItemStyles = {
  BaseStyleName: TypeStyle.style({
    ...textEllipsis,
    borderRadius: 2,
    color: applyColor(DesignTokens.color.font.default.default, '#444')+' !important',
    padding: CommonStyles.Sizes.DefaultSpace,
    $nest: {
      '&:hover, &:focus': {
        backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.hover, '#e5e5e5'),
        outline: '1px solid '+applyColor(DesignTokens.color.elevation.border.default.medium, '#939393'),
        outlineOffset: -1,
      },
      '&:active': {
        backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.dark, '#c9c9c9'),
        outline: '1px solid '+applyColor(DesignTokens.color.elevation.border.default.medium, '#939393'),
        outlineOffset: -1,
      }
    },
  }),
  AnchorStyleName: TypeStyle.style({
    display: 'block',
    textDecoration: 'none !important',
  }),
  ButtonStyleName: TypeStyle.style({
    backgroundColor: 'transparent',
    border: 'none',
    fontFamily: 'inherit',
    fontSize: 12,
    textAlign: 'left',
    width: '100% !important',
  }),
};

/**
 * This is a component that resembles Shared Widgets menu item, but under the hood
 * it is simply an anchor or a button, depending on whether or not the `url` prop is set.
 */
export class HeaderMenuItem extends React.Component<HeaderMenuItem.Props> {

  static displayName = 'HeaderMenuItem';

  static element = React.createFactory(HeaderMenuItem);

  public render() {
    if (this.props.url) {
      return React.createElement('a', {
        href: this.props.url,
        target: this.props.target,
        className: TypeStyle.classes(HeaderMenuItemStyles.BaseStyleName, HeaderMenuItemStyles.AnchorStyleName),
        'data-tb-test-id': this.props.tbTestId,
        onClick: this.props.onClick,
      }, this.props.label);
    } else {
      return React.createElement('button', {
        className: TypeStyle.classes(HeaderMenuItemStyles.BaseStyleName, HeaderMenuItemStyles.ButtonStyleName),
        'data-tb-test-id': this.props.tbTestId,
        onClick: this.props.onClick,
      }, this.props.label);
    }
  }
}

export module HeaderMenuItem {

  export interface Props {
    label: string;
    url?: string;
    onClick?: () => void;
    target?: string;
    tbTestId: string;
  }
}
